import eventManagerUtil from './event-manager-util';
import config from '../constants/config';
let ws=null;
let timeout=null;
const pingApi=()=>{
    ws.send(JSON.stringify({
        name:'ping',
    }));
};
const connect=()=>{
    ws=new WebSocket(config.API_URL+'/ws');
    ws.addEventListener('open',()=>{
        eventManagerUtil.deleteAllAndNewEvent('ws-pong',()=>{
            timeout=setTimeout(pingApi,config.WS_PING_INTERVAL);
        });
        pingApi();
        console.log('Connected to WS!');
    });
    ws.addEventListener('message',(e)=>{
        const json=JSON.parse(e.data);
        eventManagerUtil.emitAll(`ws-${json.name}`,json.payload);
    });
    ws.addEventListener('close',()=>{
        if(timeout!==null){
            clearTimeout(timeout);
        }
        setTimeout(connect,config.WS_RECONNECT_TIMEOUT);
    });
};
const sendJson=async (json)=>{
    console.assert(ws!==null);
    await new Promise((resolve)=>{
        ws.addEventListener('open',resolve);
        if(ws.readyState===WebSocket.OPEN){
            ws.removeEventListener('open',resolve);
            resolve();
        }
    });
    await new Promise((resolve)=>{
        eventManagerUtil.deleteAllAndNewEvent('ws-ack',resolve);
        ws.send(JSON.stringify(json));
    });
};
export default {
    connect,
    sendJson,
};

